import styled, { keyframes } from 'styled-components';
import WaveButtonProps from './type';
import wave from '../assets/images/WaveDark.svg';
import waveLight from '../assets/images/WaveLight.svg';

export const WaveButtonStyled = styled.button<WaveButtonProps>`
  padding: 14px;
  border-radius: 50%;
  box-sizing: border-box;
  border: 1px solid #fff;
  position: relative;
  overflow: hidden;
  max-width: 62px;
  max-height: 62px;
  min-width: 62px;
  min-height: 62px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  box-shadow: 4px 4px 14px 0px #d9d9d9 inset, -4px -4px 9px 0px rgba(255, 255, 255, 0.88) inset;

  :disabled {
    background: #fff;
    box-shadow: 4px 4px 14px 0px #d9d9d9 inset, -4px -4px 9px 0px rgba(255, 255, 255, 0.88) inset;
  }

  ${({ middleAnimation }) =>
    middleAnimation &&
    `
    color: #fff;
    .wave-dark { 
        top: 70%;
    transition-delay: 0.3s;
   }
    .wave-light {top: 60%; }
    `}

  ${({ endAnimation }) =>
    endAnimation &&
    `
    .wave-dark {
      transition: all 2s;
       top: 0%;
       transition-delay: 0.2s;
    }
    .wave-light { 
      transition: all 2s;
      top: 0% }
    `}
`;

const wavy = () => keyframes`
    0% {
      background-position-x: 0;
    }
    100% {
      background-position-x: 505px;
    }
  `;

const wavyLight = () => keyframes`
    0% {
      background-position-x: 60px;
    }
    100% {
      background-position-x: 565px;
    }
  `;

export const WaveLightStyled = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: calc(100% + 22px);
  background: #0057b8;
  transition: all 1s;
  box-sizing: border-box;
  z-index: 0;

  ::before {
    content: '';
    z-index: 1;
    position: absolute;
    width: 100%;
    height: 21px;
    top: -20px;
    left: 0%;
    background-image: url(${waveLight});
    background-repeat: repeat-x;
    background-size: cover;
    background-position-x: 60px;
    animation: ${wavyLight()} 4s linear infinite;
    animation-direction: reverse;
  }
`;

export const WaveDarkStyled = styled.div`
  box-sizing: border-box;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: calc(100% + 22px);
  background: #002752;
  transition: all 1s;
  z-index: 1;

  ::before {
    content: '';
    z-index: 1;
    position: absolute;
    width: 100%;
    height: 21px;
    top: -21px;
    left: 0%;
    background-image: url(${wave});
    background-repeat: repeat-x;
    background-size: cover;
    animation: ${wavy()} 4s linear infinite;
  }
`;
